import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-card-utility',
  templateUrl: './card-utility.component.html',
  styleUrls: ['./card-utility.component.css']
})
export class CardUtilityComponent implements OnInit {

  @Input() cardInfo;
  @Output() ctaClicked = new EventEmitter<void>(); // Emit event when CTA is clicked

  constructor() { }

  ngOnInit(): void {
  }

  openLink(link){
    window.open(link, '_blank');
  }

  onCtaClick() {
    this.ctaClicked.emit();
  }

}
